import firebase, { institutesRef } from "./firebaseconn";
import { sortList } from "../components/common/helpers";

export const getInstitute = async function (id) {
  try {
    const institute = await institutesRef.doc(id).get();

    if (!institute.data().active) throw new Error();
    return { id: institute.id, ...mapToViewModel(institute.data()) };
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getInstitutes = async function () {
  try {
    const snapshot = await institutesRef.get();

    const activeInstitutes = snapshot.docs.filter(
      (institute) => institute.data().active
    );

    const institutes = activeInstitutes.map((institute) => {
      return { id: institute.id, ...mapToViewModel(institute.data()) };
    });

    const reviewedInstitutes = institutes.filter(
      (institute) => institute.reviewAvgs
    );

    const unreviewedInstitutes = institutes.filter(
      (institute) => !institute.reviewAvgs
    );

    return [...sortList(reviewedInstitutes), ...sortList(unreviewedInstitutes)];
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createInstitute = async function (data, currentUser) {
  if (!currentUser.admin) return console.log("Unauthorized action!");
  const newData = { ...data };
  newData.createdAt = firebase.firestore.FieldValue.serverTimestamp();
  newData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
  newData.createdBy = currentUser.email;
  newData.updatedBy = currentUser.email;
  newData.active = true;

  const address = {
    country: newData.country,
    province: newData.province,
    town: newData.town,
    streetAddress: newData.streetAddress,
  };
  newData.address = address;

  const { country, province, town, streetAddress, ...rest } = newData;

  try {
    return await institutesRef.add(rest);
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateInstitute = async function (id, data, currentUser) {
  if (!currentUser.admin) return console.log("Unauthorized action!");
  const updatedData = { ...data };
  updatedData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
  updatedData.updatedBy = currentUser.email;

  const address = {
    country: updatedData.country,
    province: updatedData.province,
    town: updatedData.town,
    streetAddress: updatedData.streetAddress,
  };
  updatedData.address = address;

  const { country, province, town, streetAddress, ...rest } = updatedData;

  try {
    await institutesRef.doc(id).update(rest);
    return true;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const deleteInstitute = async function (id, currentUser) {
  if (!currentUser.admin) return console.log("Unauthorized action!");
  const data = {};
  data.deletedAt = firebase.firestore.FieldValue.serverTimestamp();
  data.deletedBy = currentUser.email;
  data.active = false;

  try {
    await institutesRef.doc(id).set(data);
    return true;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const mapToViewModel = function (institute) {
  return {
    name: institute.name,
    abbrev: institute.abbrev,
    type: institute.type,
    country: institute.address.country,
    province: institute.address.province,
    town: institute.address.town,
    streetAddress: institute.address.streetAddress,
    // fields: institute.fields, // TODO: consider having pre-defined majors
    phoneNumbers: institute.phoneNumbers,
    emails: institute.emails,
    // photoUris: institute.photoUris, // TODO: consider adding university photos in the future
    website: institute.website,
    description: institute.description,
    reviewAvgs: institute.reviewAvgs ? institute.reviewAvgs : null,
  };
};

export const removeHttpAndHttpsFromWebsite = function (data) {
  const newData = { ...data };
  if (newData && newData.website) {
    if (newData.website.startsWith("http://"))
      newData.website = newData.website.replace("http://", "");
    if (newData.website.startsWith("https://"))
      newData.website = newData.website.replace("https://", "");
  }
  return newData;
};
